import { Filter } from '~commonInfra/utils/Filter';

import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { IDetailResource, IListResource } from '../../httpClient/resources/Resource';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { ILeafFilterClause } from '../../spacesPlatform/models/IFilterClause';
import { NamedItemKeys } from '../../spacesPlatform/models/resourceParts';
import { GetUserNamesRequest } from '../../userManagement/users/serverApi/requests/GetUserNamesRequest';
import { IUserName } from '../../userManagement/users/serverApi/types/IUser';

export class UserNamesResource implements IListResource<IUserName>, IDetailResource<IUserName> {
  private listFetcher = new WebClientListResourceFetcher(GetUserNamesRequest, result => result.users);

  public all(): ResourceQuery<IUserName> {
    return new ResourceQuery(this.listFetcher);
  }

  public getById(id: string, additionalFilterClauses?: ILeafFilterClause[]): Promise<IUserName> {
    return this.all()
      .withFilters(additionalFilterClauses ?? [])
      .addFilter(Filter.stringFieldEq(NamedItemKeys.id, id))
      .getFirst();
  }

}

export const UserNames = new UserNamesResource();
